<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
      <app-left-navbar></app-left-navbar>
    </mat-sidenav>
    <mat-sidenav-content style="background-color: bisque">
      <mat-toolbar class="pageHeader">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
          *ngIf="isHandset$ | async">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <h3>Registered Applicants</h3>
      </mat-toolbar>
      <!-- Add Content Here -->
      <div class="content-body">
        <div class="main-panel">
          <div class="content-wrapper">
            <!-- Page Title Header Starts-->
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="content-header">
                  <p>
                    Select an Application Year to preview Registered Applicants.
                  </p>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="total-header">
                  <div class="row">
                    <div class="col-lg-6 col-md-7 col-sm-12 a-h">
                      <!-- Application Year -->
                      <mat-label> Application Year </mat-label>
                      <mat-form-field color="primary" appearance="fill" class="full-width">
                        <mat-select [(ngModel)]="year">
                          <mat-option *ngFor="let year of years" [value]="year.year"
                            (click)="fetchApplicantTypeListForYear(year.year)">
                            {{ year.year }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="dashboard-header">
                  <div class="row" id="card-group">
                    <mat-card class="dashboard-card-total" id="cd">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">people</mat-icon>
                      </div>
                      <p>Total</p>
                      <mat-card-content (click)="populateApplicants('All')">
                        <mat-card-title readonly id="val">{{totalApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                    <mat-card class="dashboard-card-degree" id="cd">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">school</mat-icon>
                      </div>
                      <p>Degree</p>
                      <mat-card-content (click)="populateApplicants('Bachelor')">
                        <mat-card-title readonly id="val">{{totalDegreeApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>

                    <mat-card class="dashboard-card-diploma" id="cd">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">school</mat-icon>
                      </div>
                      <p>Diploma</p>
                      <mat-card-content (click)="populateApplicants('Diploma')">
                        <mat-card-title id="val">{{totalDiplomaApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                    <mat-card class="dashboard-card-certificate" id="cd">
                      <div id="mticon">
                        <mat-icon matListIcon >card_membership</mat-icon>
                      </div>
                      <p>Certificate</p>
                      <mat-card-content (click)="populateApplicants('Certificate')">
                        <mat-card-title id="val">{{totalCertificateApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <mat-card>
                  <div id="filtcount">
                    <div class="filtcounttext">
                      <div id="cnt-text" >
                        {{filteredRowCount}}
                      </div>
                    </div>
                    <div id="filtcountinput">
                      <input  matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12" id="divTable">
                      <table id="table" mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-striped" matSort (matSortChange)="sortData($event)">
                        <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->
  
                        <!-- Applicant ID Column -->
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                          <td data-label="ID" class="app-id" mat-cell *matCellDef="let element">
                            <a (click)="goToApplicantDetails(element.personId)">{{element.personId}}</a>
                          </td>
                        </ng-container>
  
                        <!-- Applicant Name -->
                        <ng-container matColumnDef="Applicant">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Applicant</th>
                          <td data-label="Name" mat-cell *matCellDef="let element">{{ element.applicantName }}</td>
                        </ng-container>
  
                        <!-- Programme Type -->
                        <ng-container matColumnDef="ProgrammeType">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Programme</th>
                          <td data-label="Programme" mat-cell *matCellDef="let element">{{ element.programmeType }}</td>
                        </ng-container>
  
                        <!--   Index number-->
                        <ng-container matColumnDef="Reg.Number">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Reg.Number</th>
                          <td data-label="Registration Number" mat-cell *matCellDef="let element">{{ element.registrationNumber }}</td>
                        </ng-container>
  
                        <!-- Country -->
                        <ng-container matColumnDef="Country">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
                          <td data-label="Country" mat-cell *matCellDef="let element">
                            {{ element.country }}
                          </td>
                        </ng-container>
  
                        <!-- City -->
                        <ng-container matColumnDef="Hometown">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Hometown</th>
                          <td data-label="Hometown" mat-cell *matCellDef="let element">{{ element.hometown }}</td>
                        </ng-container>
  
                        <!-- Sex -->
                        <ng-container matColumnDef="Sex">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sex</th>
                          <td data-label="Sex" mat-cell *matCellDef="let element">{{ element.gender }}</td>
                        </ng-container>
  
                        <!-- Application Received Date -->
                        <ng-container matColumnDef="Date">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                          <td data-label="Date" mat-cell *matCellDef="let element"> {{element.applicationReceivedDate}} </td>
                        </ng-container>

                         <!-- Semester registered -->
                         <ng-container matColumnDef="Semester">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Semester </th>
                          <td data-label="Semester" mat-cell *matCellDef="let element"> {{element.semester}} </td>
                        </ng-container>
  
                        <!-- Status -->
                        <ng-container matColumnDef="Status">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Status
                          </th>
                          <td data-label="Status" mat-cell *matCellDef="let element">
                            {{ element.status }}
                          </td>
                        </ng-container>
                       
  
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" id="tr"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns" id="tr"></tr>
                      </table>
                      <mat-paginator #paginator [length]="100" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                        showFirstLastButtons>
                      </mat-paginator>
                    </div>
                  </div>
                </mat-card>
                <button class="floating-button" (click)="exportExcel()">
                  <mat-icon>cloud_download</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
